import { Box } from "@material-ui/core";
import {
  AutoComplete,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  message,
  Row,
  Typography,
} from "antd";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCities,
  updateCityToactive,
} from "../../../Redux/ActionCreaters/citiesRequets";
import {
  getCommodity,
  getDateTimeString,
} from "../../../Redux/ActionCreaters/CommodityRequets";
import { AddCity } from "../../../RestServices/authService";
import { bulkPredictRates } from "../../../RestServices/postingService";
import { itemProducts } from "../../../shared";
import ProvinceDropDown from "../../../utils/dropDown/ProvinceDropDown";
import ModalUtil from "../../../utils/Modal/Modal";
import "./body.css";
import CategoryDropDown from "./CategoryDropDown";
import CommodityRatesDivs from "./CommodityRatesDivs";
import RateCopyModal from "./CopyRate";
import BulkRateEntry from "./BulkRateEntry";

const Body = () => {
  const { cities, provinces, allcities } = useSelector((state) => state.Cities);
  const [product, setProduct] = useState(itemProducts[0]);
  const [province, setProvince] = useState("");
  const [selectedDate, setSelectedDate] = useState(moment());
  const [getRate, setGetRate] = useState(0);

    const [addDivision, setaddDivision] = useState("");
  const [addDistrict, setaddDistrict] = useState("");
  const [addProvince, setaddProvince] = useState("");

  const [addCityModalVisible, setAddCityModalVisible] = useState(false);

  const [addCityModalLoading, SetaddCityModalLoading] = useState(false);
  const [isPredicting, setIsPredicting] = useState(false);

  // const [getRate, setGetRate] = useState(0);


  useEffect(() => {
    if (!province) {
      setProvince(provinces ? provinces[0] : "");
    }
  }, [provinces]);
  const { token } = useSelector((state) => state.Authentication.user);

  const dispatch = useDispatch();
  const [allDivistion, setallDivistion] = useState([]);
  const [allDistrict, setAllDistrict] = useState([]);
  const [allCities, setAllCities] = useState([]);

  
  useEffect(() => {
    if (province) {
      dispatch(getCommodity(product, province, token, selectedDate?.format("YYYY-MM-DD")));
      setallDivistion(cities.filter(item => item.province === addProvince).map((val) => val.division));
     
    }
    if (addProvince && addDivision) {
       
      setAllDistrict(cities.find(item=>item.province===addProvince &&  item.division===addDivision)?.cities.map(value=>String(value.name).toLowerCase()));
     }
  }, [getRate,addProvince, addDivision ,province, selectedDate]);
  useEffect(() => {
    if (province) {
      dispatch(getDateTimeString({ province, product }, token));
    }
  }, [province, product]);
  const changeProduct = (product) => {
    dispatch(getCommodity(product, province, token, selectedDate?.format("YYYY-MM-DD")));
    setProduct(product);
  };
  const changeProvince = (province) => {
    dispatch(getCommodity(product, province, token, selectedDate?.format("YYYY-MM-DD")));
    // dispatch(getDateTimeString({ province, product }, token));

    setProvince(province);
  };
  const addCityButtonFuction = async (e, data) => {
    e.stopPropagation();
    let newCity = false;
    if (provinces && provinces.indexOf(addProvince?.toLowerCase()) === -1) {
      newCity = true;
    }
    if (
      allDivistion &&
      allDivistion.indexOf(addDivision?.toLowerCase()) === -1
    ) {
      newCity = true;
    }
    if (allCities && allCities.indexOf(addDistrict?.toLowerCase()) === -1) {
      newCity = true;
    }
    console.log(newCity, "add new cityes");
    if (newCity === true) {
      const payload = {
        cities: [
          {
            isActive: true,
            name: addDistrict?.toLowerCase(),
            value: addDistrict?.toLowerCase(),
            division: addDivision?.toLowerCase(),
            district: addDistrict?.toLowerCase(),
            en: addDistrict?.toLowerCase(),
            province: addProvince?.toLowerCase(),
            activeForProduct: [product],
          },
        ],
      };
      SetaddCityModalLoading(true);

      try {
        const responce = await AddCity(payload, token);
        handleAddcityModalOnCancle();
        dispatch(getAllCities(token));
        message.success(
          `city is added into the ${addProvince} province in ${addDivision} for ${product} commodity`,
        );
      } catch (err) {
        console.log(err);
        if (err.response) {
          message.error(err.response.data.message);
        } else {
          message.error(err.message);
        }
      } finally {
        SetaddCityModalLoading(false);
      }
    } else {
      let cityToBeUpdate = allcities.find(
        (valu) => valu.value == addDistrict?.toLowerCase(),
      );
      dispatch(
        updateCityToactive(
          cityToBeUpdate._id,
          { product },
          token,
          cities,
          addDivision,
          getCities,
        ),
      );
      handleAddcityModalOnCancle();
    }
  };
  const getCities = () => {
    dispatch(getAllCities(token));
  };
  const handleAddcityModalOnCancle = () => {
    // this.setState({ city: "", addCityModalVisible: false });
    setAddCityModalVisible(false);
    setaddNewCityFlag(false);
    setaddDivision("");
    setaddDistrict("");
    setaddProvince("");
    SetaddCityModalLoading(false);
  };
  const [addNewCityFlag, setaddNewCityFlag] = useState(false);

  const whenProvinceChange = (value) => {
    setaddProvince(value);
  };
  const whenChnageDivision = (value) => {
    setaddDivision(value);
    if (allDivistion.indexOf(addDivision?.toLowerCase()) === -1) {
      const divistionFind =
        cities && cities.find((val) => val.division === value);
      setAllCities(
        divistionFind &&
        divistionFind.cities &&
        divistionFind.cities.map((item) => item.value),
      );
    }
  };
  const whenChnageDistrict = (value) => {
    setaddDistrict(value);
  };



  const { Title } = Typography;
  return (
    <div>
      <ModalUtil
        timerModalVisible={addCityModalVisible}
        timerModalLoading={addCityModalLoading}
        showTimerModal={addCityModalVisible}
        handleTimerModalOnOk={addCityButtonFuction}
        handleTimerModalOnCancle={handleAddcityModalOnCancle}
        title="add city"
      >
        <Row style={{ margin: "20px" }}>
          <Form
            style={{ padding: "20px", width: "100%" }}
            colon={false}
            layout="vertical"
            onSubmit={addCityButtonFuction}
          >
            <Typography.Text>
              {/* Please enter the city to add in {division} division. */}
            </Typography.Text>
            <Form.Item label="Province" required>
              <AutoComplete
                // style={{ width: 200 }}
                style={{ background: "white", color: "black" }}
                dataSource={provinces}
                value={addProvince}
                onChange={(e) => whenProvinceChange(e)}
                placeholder="province"
                filterOption={(inputValue, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(inputValue.toLowerCase()) !== -1
                }
              />
            </Form.Item>
            <Form.Item label="Division" required>
              <AutoComplete
                // style={{ width: 200 }}
                style={{ background: "white", color: "black" }}
                dataSource={allDivistion}
                value={addDivision}
                onChange={(e) => whenChnageDivision(e)}
                placeholder="Division"
                filterOption={(inputValue, option) =>
                  option.props.children
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              />
              {/* <Input
                size="large"
                type="text"
                name="district"
                onChange={(e) => SetaddDistrict(e.target.value)}
                value={addDistrict}
                placeholder="district Name"
              /> */}
            </Form.Item>
            <Form.Item label="Distict" required>
              <AutoComplete
                style={{ background: "white", color: "black" }}
                dataSource={allDistrict}
                value={addDistrict}
                onChange={(e) => whenChnageDistrict(e)}
                placeholder="ditrict"
                filterOption={(inputValue, option) =>
                  option.props.children
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              />
            </Form.Item>
          </Form>
        </Row>
      </ModalUtil>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div style={{ padding: "10px" }}>
            <Card style={{ paddingLeft: "10px", paddingRight: "10px" }}>
              <Row gutter={[16, 16]} align="bottom" justify="space-between">
                <Col xs={24} sm={12} md={5} lg={4} xl={4}>
                  <div className="flex-col">
                    <Title level={5} className="mb-0 text-primary">Select Province</Title>
                    <ProvinceDropDown
                      selectProvince={changeProvince}
                      selectedProvince={province}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={12} md={5} lg={4} xl={4}>
                  <div className="flex-col">
                    <Title level={5} className="mb-0 text-primary">Select Category</Title>
                    <CategoryDropDown
                      itemProducts={itemProducts}
                      selectedProduct={product}
                      setProduct={changeProduct}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={12} md={5} lg={4} xl={4}>
                  <div className="flex-col">
                    <Title level={5} className="mb-0 text-primary">Select Date</Title>
                    <DatePicker 
                      style={{ width: '100%' }}
                      size="large"
                      value={selectedDate}
                      onChange={(date) => setSelectedDate(date)}
                      format="YYYY-MM-DD"
                    />
                  </div>
                </Col>
               
                <Col xs={24} sm={24} md={10} lg={9} xl={9}>
                  <div className="flex-between mt-mobile-10" style={{ gap: "8px", justifyContent: "flex-end" }}>
                    <BulkRateEntry currentDate={selectedDate} />
                    <Button type="primary" size="large" onClick={(e) => setAddCityModalVisible(true)}>
                      Add City
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div style={{ padding: "10px" }}>
            <Card>
              <Box className="flex-between">
                <Title level={3} className="mb-0 text-primary">Commodity Rates Lists</Title>
                <RateCopyModal />
              </Box>

              {cities &&
                cities.map((val, key) => {
                  return province === val.province ? (
                    <Fragment key={key}>
                      <CommodityRatesDivs
                        cities={val.cities}
                        Heading={val.division}
                        product={product}
                        province={province}
                      />
                    </Fragment>
                  ) : null;
                })}
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Body;
